import React from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { Anchor, Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	canAdministerJira: boolean;
	helpCenterUrl?: URL;
};

export const CustomizeHelpCenter = (props: Props) => {
	const { canAdministerJira, helpCenterUrl } = props;
	const { formatMessage } = useIntl();

	const getHelpCenterUrl = () => {
		if (helpCenterUrl) {
			helpCenterUrl.searchParams.append('customize', 'true');
			return helpCenterUrl.toString();
		}
		return '';
	};

	if (canAdministerJira) {
		return (
			<Root>
				<HorizontalRule />
				<Box xcss={headingContainerStyles}>
					<Heading as="h2" size="small">
						{formatMessage(messages.customizeHelpCenter)}
					</Heading>
				</Box>
				<br />
				{formatMessage(messages.customizeHelpCenterMessage)}
				<br />
				<br />
				<Anchor href={getHelpCenterUrl()} target="_blank">
					{formatMessage(messages.customizeHelpCenterLink)}
				</Anchor>
			</Root>
		);
	}
	return <></>;
};

export default CustomizeHelpCenter;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Root = styled.div({
	paddingBottom: token('space.400', '32px'),
	width: '64%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HorizontalRule = styled.hr({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.border', colors.N40),
	height: '1px',
	border: 0,
});

const headingContainerStyles = xcss({
	marginTop: 'space.300',
});
